const DIALOG_SELECTOR = '[data-dialog]';
const CLOSE_SELECTOR = '[data-dialog-close]';


export function init() {
    document.addEventListener('click', ev => {
        const el = ev.target.closest(DIALOG_SELECTOR);
        if (!el) {
            return;
        }

        const dialog = document.querySelector(el.dataset.dialog);
        if (!dialog) {
            return;
        }

        dialog.showModal();
    });
    document.addEventListener('click', ev => {
        const dialog = ev.target.closest(CLOSE_SELECTOR)?.closest('dialog');

        if (!dialog) {
            return;
        }

        dialog.close();
    });
}

